(function(){
    angular
        .module('appback')
        .directive('ngCamfoto', camToFoto);

        camToFoto.$inject = ['socket','GenerallabService','ResultadosService','$timeout'];
        function camToFoto(socket,GenerallabService,ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/resultadopeticion/templateresultados?name=camfoto.twig',
		        scope: {
                  objectnode: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.camera = false;
						let video = $(element).find(".video")[0];//.querySelector(".video");
						let canvas = $(element).find(".canvas")[0];//.querySelector(".video");
						console.log(scope);
						scope.startCamera = async function(){
		            	scope.camera = true;
							console.log("video",video);
						   	let stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
							video.srcObject = stream;
						}
						
						scope.captureFoto =  function(){
							canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
						   	let image_data_url = canvas.toDataURL('image/jpeg');
						   	ResultadosService.base64toJPG("accion",image_data_url,function(res){
						   		console.log(res);
						   		if(angular.isUndefined(scope.objectnode.fotos)){
						   			scope.objectnode.fotos = [];
						   		}
						   		scope.objectnode.fotos.push(res);
						   	})
						   	// data url of the image
						   	//console.log(image_data_url);
						}
						
			        });



					
		        }
          }
      }
})();